<template>
    <div>
        <button-white @click="showModal = true"> Bearbeiten</button-white>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Zeitslot bearbeiten</template>

                <loading v-show="loading"></loading>

                <confirm-dialog @confirmed="remove">
                    <button-delete><i class="fa fa-trash"></i> Zeitslot löschen</button-delete>
                    <template slot="question">Soll der Zeitslot <span class="font-bold">{{ local.name }}</span> wirklich
                        gelöscht werden?
                    </template>
                    <template slot="header">Zeitslot löschen</template>
                    <template slot="confirm">
                        <button-delete><i class="fa fa-trash"></i> Löschen</button-delete>
                    </template>
                </confirm-dialog>


                <div v-show="!loading">
                    <input-text v-model="local.name">
                        Name
                    </input-text>

                    <input-text type="number" v-model="local.begin">
                        Startzeit
                    </input-text>

                    <input-text type="number" v-model="local.end">
                        Endzeit
                    </input-text>
                </div>

                <template slot="action">
                    <button-primary @click="save"><i class="fa fa-save"></i> Speichern</button-primary>
                </template>
            </modal>
        </portal>

    </div>
</template>

<script>
import ButtonSecondary from "./UI/ButtonSecondary";
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import Loading from "./UI/Loading";
import InputText from "./UI/InputText";
import ButtonWhite from "./UI/ButtonWhite";
import ButtonDelete from "./UI/ButtonDelete";
import ConfirmDialog from "./UI/ConfirmDialog";

export default {

    name: "SlotEdit",

    props: {
        value: {},
    },

    components: {ConfirmDialog, ButtonDelete, ButtonWhite, InputText, Loading, ButtonPrimary, Modal, ButtonSecondary},

    inject: ['group'],

    data: (vm) => ({
        showModal: false,
        loading: false,
        local: Object.assign({}, vm.value), // create local copy of item
    }),

    methods: {
        save() {
            this.loading = true;
            window.axios.post(`/admin/slots/${this.local.id}`, {
                _method: 'put',
                name: this.local.name,
                begin: this.local.begin,
                end: this.local.end,
                public_id: this.local.public_id,
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$emit('reload');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        remove() {
            this.loading = true;
            window.axios.post(`/admin/slots/${this.local.id}`, {
                _method: 'delete'
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$emit('reload');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>